"use client";

import { c as _c } from "react/compiler-runtime";
import { Text, Box, HStack, VStack, Link, Card, Spinner, Popover, Portal, Switch, SystemStyleObject } from "@chakra-ui/react";
import posthog from "posthog-js";
import Pill from "./pill";
import { RxCross2 } from "react-icons/rx";
import { PillData } from "../data/data";
import { hazardMapConfigByName } from "../data/hazard-map-config";
import { FaCircle, FaSquareFull } from "react-icons/fa";
import { KeyElem } from "./key-elem";
import { Dispatch, SetStateAction, useState } from "react";
import { LayerToggleObjProps } from "./address-mapper";
export interface HazardProps {
  id: number;
  name: string;
  title: string;
  description: string;
  info: string[];
  link: {
    label: string;
    url: string;
  };
  icon?: "circle" | "square";
  iconColor?: SystemStyleObject["color"];
}
export interface CardHazardProps {
  hazard: HazardProps;
  hazardData?: {
    exists?: boolean;
    last_updated?: string;
    risk_rating?: string;
  };
  showData: boolean;
  isHazardDataLoading: boolean;
  toggledStates: boolean[];
  setToggledStates: Dispatch<SetStateAction<boolean[]>>;
  setLayerToggleObj: Dispatch<SetStateAction<LayerToggleObjProps>>;
  fullWidth?: boolean;
}
const CardHazard: React.FC<CardHazardProps> = t0 => {
  const $ = _c(87);
  const {
    hazard,
    hazardData,
    showData,
    isHazardDataLoading,
    toggledStates,
    setToggledStates,
    setLayerToggleObj,
    fullWidth: t1
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const {
    id,
    title,
    name,
    description,
    icon,
    iconColor
  } = hazard;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [{
      name: "Relatively Low",
      label: "Low",
      color: "femaRisk.low"
    }, {
      name: "Relatively Moderate",
      label: "Moderate",
      color: "femaRisk.moderate"
    }, {
      name: "Relatively High",
      label: "High",
      color: "femaRisk.high"
    }, {
      name: "Very High",
      label: "Very High",
      color: "femaRisk.veryHigh"
    }];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const riskRanges = t2 as const;
  let t3;
  if ($[1] !== hazardData) {
    t3 = hazardData || {};
    $[1] = hazardData;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    exists
  } = t3;
  let t4;
  if ($[3] !== name) {
    t4 = PillData.find(object => object.name === name) ?? {
      trueData: "No Data",
      falseData: "No Data",
      noData: "No Data"
    };
    $[3] = name;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const pillTextOptions = t4;
  const mapConfig = hazardMapConfigByName[name];
  const [isMoreInfo, setIsMoreInfo] = useState(false);
  let t5;
  if ($[5] !== exists || $[6] !== hazard.name || $[7] !== hazardData?.risk_rating || $[8] !== isHazardDataLoading || $[9] !== pillTextOptions || $[10] !== showData) {
    t5 = isHazardDataLoading ? <Spinner size="xs" /> : showData ? <Pill exists={exists} trueData={hazardData?.risk_rating || pillTextOptions.trueData} falseData={pillTextOptions.falseData} noData={pillTextOptions.noData} variant={hazard.name === "femaRisk" ? "reverse" : "pill"} pillBackgroundColor={hazard.name === "femaRisk" ? riskRanges.find(r => r.name === hazardData?.risk_rating)?.color || undefined : undefined} /> : "";
    $[5] = exists;
    $[6] = hazard.name;
    $[7] = hazardData?.risk_rating;
    $[8] = isHazardDataLoading;
    $[9] = pillTextOptions;
    $[10] = showData;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const hazardPill = t5;
  let t6;
  if ($[12] !== hazard.info) {
    t6 = () => hazard.info.map(_temp);
    $[12] = hazard.info;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const buildHazardCardInfo = t6;
  let t7;
  if ($[14] !== mapConfig?.layerIds || $[15] !== setLayerToggleObj || $[16] !== setToggledStates || $[17] !== toggledStates) {
    t7 = (num, checked) => {
      const newArray = [...toggledStates];
      newArray[num] = checked;
      setToggledStates(newArray);
      setLayerToggleObj({
        layerIds: mapConfig?.layerIds ?? [],
        toggleState: checked
      });
    };
    $[14] = mapConfig?.layerIds;
    $[15] = setLayerToggleObj;
    $[16] = setToggledStates;
    $[17] = toggledStates;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleSwitchClick = t7;
  let t8;
  if ($[19] !== icon) {
    t8 = icon === "circle" ? <FaCircle /> : icon === "square" ? <FaSquareFull /> : undefined;
    $[19] = icon;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const legacyIcon = t8;
  let t9;
  if ($[21] !== fullWidth) {
    t9 = fullWidth ? "none" : {
      base: "xs",
      "2xl": "sm"
    };
    $[21] = fullWidth;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      base: "3.5",
      md: "4"
    };
    t11 = {
      base: "4",
      md: "5"
    };
    $[23] = t10;
    $[24] = t11;
  } else {
    t10 = $[23];
    t11 = $[24];
  }
  const t12 = fullWidth ? "full" : "auto";
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      placement: "bottom",
      flip: false,
      offset: {
        crossAxis: -12,
        mainAxis: 24
      },
      sameWidth: true
    };
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = `${hazard.title} information`;
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = e => setIsMoreInfo(e.open);
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = mapConfig?.legend;
  let t17;
  if ($[27] !== iconColor || $[28] !== legacyIcon || $[29] !== t16 || $[30] !== title) {
    t17 = <KeyElem name={title} legend={t16} color={iconColor} icon={legacyIcon} />;
    $[27] = iconColor;
    $[28] = legacyIcon;
    $[29] = t16;
    $[30] = title;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = toggledStates[id];
  let t19;
  if ($[32] !== handleSwitchClick || $[33] !== id) {
    t19 = e_0 => handleSwitchClick(id, e_0.checked);
    $[32] = handleSwitchClick;
    $[33] = id;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  let t21;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Switch.HiddenInput />;
    t21 = <Switch.Control />;
    $[35] = t20;
    $[36] = t21;
  } else {
    t20 = $[35];
    t21 = $[36];
  }
  let t22;
  if ($[37] !== title) {
    t22 = <Switch.Label srOnly={true}>Show {title} on map</Switch.Label>;
    $[37] = title;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t18 || $[40] !== t19 || $[41] !== t22) {
    t23 = <Switch.Root size="lg" colorPalette="blue" checked={t18} onCheckedChange={t19} defaultChecked={true} gap="0">{t20}{t21}{t22}</Switch.Root>;
    $[39] = t18;
    $[40] = t19;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t17 || $[44] !== t23) {
    t24 = <Card.Header w="full" p="0" mb="1" textAlign="left" flexDirection="row" justifyContent="space-between">{t17}{t23}</Card.Header>;
    $[43] = t17;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== hazard.name) {
    t25 = hazard.name === "femaRisk" && <Box width="full"><HStack gap="0" mb="1">{riskRanges.map(_temp2)}</HStack><HStack gap="0" width="full" mb="5">{riskRanges.map((range_0, index_0) => <Box key={range_0.label} flex="1" height="2.5" bg={range_0.color} border="sm" borderRight={index_0 < riskRanges.length - 1 ? "none" : "sm"} borderColor="femaRisk.veryHigh" borderRadius="none" />)}</HStack></Box>;
    $[46] = hazard.name;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== description) {
    t26 = <Text textStyle="cardTextMedium" layerStyle="text">{description}</Text>;
    $[48] = description;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t25 || $[51] !== t26) {
    t27 = <Card.Body textAlign="left" p="0" mb="1.5">{t25}{t26}</Card.Body>;
    $[50] = t25;
    $[51] = t26;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== hazard.name || $[54] !== isMoreInfo) {
    t28 = () => {
      if (!isMoreInfo) {
        posthog.capture("more-info-clicked", {
          hazard_name: hazard.name
        });
      }
    };
    $[53] = hazard.name;
    $[54] = isMoreInfo;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  const t29 = !isMoreInfo ? "More info" : "Less info";
  let t30;
  if ($[56] !== t28 || $[57] !== t29) {
    t30 = <Popover.Trigger><Text cursor="button" textDecoration="underline" onClick={t28}>{t29}</Text></Popover.Trigger>;
    $[56] = t28;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== hazardPill || $[60] !== t30) {
    t31 = <Card.Footer p="0" width="full"><HStack justifyContent="space-between" width="full">{t30}{hazardPill}</HStack></Card.Footer>;
    $[59] = hazardPill;
    $[60] = t30;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t24 || $[63] !== t27 || $[64] !== t31) {
    t32 = <VStack alignItems="flex-start" flexGrow={1} h="full">{t24}{t27}{t31}</VStack>;
    $[62] = t24;
    $[63] = t27;
    $[64] = t31;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Popover.CloseTrigger cursor="button" position="absolute" top="2" right="2"><RxCross2 color="grey.900" size="20" data-testid="clear-icon" /></Popover.CloseTrigger>;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Popover.Arrow><Popover.ArrowTip /></Popover.Arrow>;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] !== buildHazardCardInfo) {
    t35 = buildHazardCardInfo();
    $[68] = buildHazardCardInfo;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] !== hazard.link.label) {
    t36 = () => posthog.capture("dataset-link-clicked", {
      link_name: hazard.link.label
    });
    $[70] = hazard.link.label;
    $[71] = t36;
  } else {
    t36 = $[71];
  }
  let t37;
  if ($[72] !== hazard.link.label || $[73] !== hazard.link.url || $[74] !== t36) {
    t37 = <Link display="inline-block" href={hazard.link.url} mt="4" target="_blank" rel="noopener noreferrer" textDecoration="underline" onClick={t36}>{hazard.link.label}</Link>;
    $[72] = hazard.link.label;
    $[73] = hazard.link.url;
    $[74] = t36;
    $[75] = t37;
  } else {
    t37 = $[75];
  }
  let t38;
  if ($[76] !== t35 || $[77] !== t37) {
    t38 = <Portal><Popover.Positioner><Popover.Content maxHeight="unset">{t33}{t34}<Popover.Body>{t35}{t37}</Popover.Body></Popover.Content></Popover.Positioner></Portal>;
    $[76] = t35;
    $[77] = t37;
    $[78] = t38;
  } else {
    t38 = $[78];
  }
  let t39;
  if ($[79] !== t14 || $[80] !== t32 || $[81] !== t38) {
    t39 = <Popover.Root positioning={t13} closeOnEscape={true} closeOnInteractOutside={true} aria-label={t14} onOpenChange={t15}>{t32}{t38}</Popover.Root>;
    $[79] = t14;
    $[80] = t32;
    $[81] = t38;
    $[82] = t39;
  } else {
    t39 = $[82];
  }
  let t40;
  if ($[83] !== t12 || $[84] !== t39 || $[85] !== t9) {
    t40 = <Card.Root flex={1} maxW={t9} py={t10} px={t11} variant="elevated" w={t12}>{t39}</Card.Root>;
    $[83] = t12;
    $[84] = t39;
    $[85] = t9;
    $[86] = t40;
  } else {
    t40 = $[86];
  }
  return t40;
};
export default CardHazard;
function _temp(infoItem, index) {
  return <Text as="p" mt="4" key={index}>{infoItem}</Text>;
}
function _temp2(range) {
  return <Text key={range.label} flex="1" fontSize="xs">{range.label}</Text>;
}